import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppServices } from '../../AppServices';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ApplicationState } from '../../store';
import * as SharedMaterialsStateModels from '../../store/Models/SharedMaterials/BrowserStateModels';
import * as SharedMaterialsDatabaseStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';

import './SharedMaterialRequestComponentBase.css';

type OperationProps =
    ToxnotComponentProperties &
    SharedMaterialsDatabaseStateController.SharedMaterialsState &
    typeof SharedMaterialsDatabaseStateController.actionCreators &
    RouteComponentProps;

export abstract class SharedMaterialRequestComponentBase extends ToxnotSignInRequiredComponent<OperationProps> {
    protected renderConcreteComponent() {
        const requestState = this.props.requestState?.state ?? SharedMaterialsStateModels.RequestState.Default;

        const title = this.getLocalizedTitle();
        const description = this.getLocalizedDescription();

        return (
            <div className="tn-section">
                {(title.length > 0) &&
                    <div className="tn-section-row tn-section-heading-row">
                        <div className="tn-section-col-12">
                            <h1>{title}</h1>
                        </div>
                    </div>
                }
                <div className="tn-section-row">
                    <div className="tn-section-col-12">
                        {(description.length > 0) &&
                            <div className="alert alert-info">
                                {description}
                            </div>}
                        <div id="request-status-container">
                            {requestState === SharedMaterialsStateModels.RequestState.Sending && <div className="alert alert-info">{this.localizeString("Sending...")}</div>}
                            {requestState === SharedMaterialsStateModels.RequestState.Sent && <div className="alert alert-success">{this.localizeString("Sent Successfully!")}</div>}
                            {requestState === SharedMaterialsStateModels.RequestState.FailedToSend && <div className="alert alert-danger">{this.localizeString("Sorry, there was a problem sending your request.")}</div>}
                        </div>
                        {requestState === SharedMaterialsStateModels.RequestState.Default && this.renderForm()}
                    </div>
                </div>
                <div className="share-material-bottom-buttons">
                    {requestState === SharedMaterialsStateModels.RequestState.Default && (
                        <p>
                            <button className="btn btn-default" onClick={this.doneButton_click}>{this.localizeString("Cancel")}</button> <button type="button" id="send-email-button" className="btn btn-toxnot-primary" onClick={e => this.submitButton_click()}>Send</button>
                        </p>)}
                    {requestState === SharedMaterialsStateModels.RequestState.Sent && (
                        <p>
                            <button className="btn btn-toxnot-primary" onClick={this.doneButton_click}>{this.localizeString("Done")}</button>
                        </p>)}
                    {requestState === SharedMaterialsStateModels.RequestState.FailedToSend && (
                        <p>
                            <button className="btn btn-default" onClick={this.doneButton_click}>{this.localizeString("Cancel")}</button>
                        </p>)}
                </div>
            </div>
        );
    }

    // ===============================================================================

    protected getRouteParams<T>() {
        return this.props.match.params as T;
    }

    // ===============================================================================

    protected abstract renderForm(): JSX.Element;

    protected abstract submitButton_click(): void;

    protected abstract getLocalizedDescription(): string;

    protected abstract getLocalizedTitle(): string;

    // ===============================================================================

    private doneButton_click = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.props.history.goBack();
    }
}

// ===============================================================================

export const getSharedMaterialRequestState = (state: ApplicationState) => ({ ...state.sharedMaterialsState, appServices: state.appServices });
